<template>
  <ReviewMetaSchema
    :itemprop="SCHEMA_ITEM_PROP.REVIEW_RATING"
    itemscope
    :itemtype="SCHEMA_ITEM_TYPE.RATING"
    :rating="rating"
  />
</template>

<script lang="ts">

import {
  SCHEMA_ITEM_TYPE,
  SCHEMA_ITEM_PROP,
} from '~~/constants/seo';

export default defineComponent({
  name: 'ReviewRatingSchema',

  props: {
    rating: {
      type: Number,
      required: true,
    },
  },
  setup() {

    return {
      SCHEMA_ITEM_TYPE,
      SCHEMA_ITEM_PROP,
    };
  
  },
});

</script>
